import React from 'react'
import { RecoilRoot } from 'recoil'

const wrapWithProvider = ({ element, props }) => {
    return (
        <RecoilRoot {...props}>{element}</RecoilRoot>
    )
}
export default wrapWithProvider